__turbopack_context__.v({
  "body": "vehicle-card-module__ZFUaZG__body",
  "bookedFlag": "vehicle-card-module__ZFUaZG__bookedFlag",
  "card": "vehicle-card-module__ZFUaZG__card",
  "cardBooked": "vehicle-card-module__ZFUaZG__cardBooked",
  "categoryChip": "vehicle-card-module__ZFUaZG__categoryChip",
  "code": "vehicle-card-module__ZFUaZG__code",
  "cta": "vehicle-card-module__ZFUaZG__cta",
  "ctaDisabled": "vehicle-card-module__ZFUaZG__ctaDisabled",
  "depositNote": "vehicle-card-module__ZFUaZG__depositNote",
  "discountChip": "vehicle-card-module__ZFUaZG__discountChip",
  "feeFree": "vehicle-card-module__ZFUaZG__feeFree",
  "feeNote": "vehicle-card-module__ZFUaZG__feeNote",
  "fromWord": "vehicle-card-module__ZFUaZG__fromWord",
  "gelCode": "vehicle-card-module__ZFUaZG__gelCode",
  "gelNote": "vehicle-card-module__ZFUaZG__gelNote",
  "marginNote": "vehicle-card-module__ZFUaZG__marginNote",
  "media": "vehicle-card-module__ZFUaZG__media",
  "metaLine": "vehicle-card-module__ZFUaZG__metaLine",
  "moreShots": "vehicle-card-module__ZFUaZG__moreShots",
  "noDeposit": "vehicle-card-module__ZFUaZG__noDeposit",
  "noPhoto": "vehicle-card-module__ZFUaZG__noPhoto",
  "perDayNow": "vehicle-card-module__ZFUaZG__perDayNow",
  "perDayWas": "vehicle-card-module__ZFUaZG__perDayWas",
  "photo": "vehicle-card-module__ZFUaZG__photo",
  "photoHover": "vehicle-card-module__ZFUaZG__photoHover",
  "priceBlock": "vehicle-card-module__ZFUaZG__priceBlock",
  "priceRail": "vehicle-card-module__ZFUaZG__priceRail",
  "propulsion": "vehicle-card-module__ZFUaZG__propulsion",
  "sub": "vehicle-card-module__ZFUaZG__sub",
  "subDays": "vehicle-card-module__ZFUaZG__subDays",
  "subX": "vehicle-card-module__ZFUaZG__subX",
  "title": "vehicle-card-module__ZFUaZG__title",
  "titleLink": "vehicle-card-module__ZFUaZG__titleLink",
  "total": "vehicle-card-module__ZFUaZG__total",
  "totalNow": "vehicle-card-module__ZFUaZG__totalNow",
  "year": "vehicle-card-module__ZFUaZG__year",
});
